<template>
    <el-row type="flex" class="row-bg" justify="space-between">
        <el-col :span="14" style="margin-top: 22px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item 
                    v-for="(item, idx) in breadcrumbs"
                    :to="{ path: item['path'] }"
                    :key="idx"
                >
                    {{item['name']}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </el-col>
        <el-col :span="10" style="text-align: right;">
            <NotificationList />
            
            <span>
                <el-button icon="el-icon-warning" @click="handleReportPopup"></el-button>
            </span>
            <!-- <el-dropdown>
                <span class="el-dropdown-link">
                    <i class="el-icon-warning"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>回報問題</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown> -->
            <el-dropdown>
                <!-- <span class="el-dropdown-link">
                    {{this.account_info['username']}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span> -->
                <el-button>
                    {{this.account_info['username']}}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <div class="personal-panel">
                        <el-row>
                            <h3>{{this.account_info['username']}}</h3>
                            <p>{{this.account_info['org_name']}}</p>
                            <p>{{this.roles}}</p>
                        </el-row>
                        <el-row>
                            <el-button type="primary" @click="password_dialog_visible=true">變更密碼</el-button>
                            <el-button type="warning" @click="handle_logout">登出</el-button>
                        </el-row>
                    </div>
                </el-dropdown-menu>
            </el-dropdown>
        </el-col>

        <QuestionReport 
            :isOpen.sync="QRIsOpen"
            @child-addReport="handleAddReport">			
        </QuestionReport>

        <el-dialog
          title="變更密碼"
          :visible.sync="password_dialog_visible"
          :append-to-body="true"
          width="30%"
          center
        >
            <PasswordEditPage
                @done="password_dialog_visible=false"
                :update_flag="password_dialog_update_flag"
            />
        </el-dialog>
    </el-row>

		
</template>

<script>
// @ is an alias to /src
//import Main from '@/components/backstage/Main.vue'
import QuestionReport from '@/components/backstage/QuestionReport/QuestionReport.vue'
import PasswordEditPage from '@/views/backstage/pages/system_management/account_management/PasswordEditPage.vue'
import breadcrumbMixin from '@/mixins/breadcrumbMixin'
import NotificationList from '@/components/backstage/Header/NotificationList.vue'

export default {
    mixins: [breadcrumbMixin],
    components: {
        QuestionReport,
        PasswordEditPage,
        NotificationList
    },
    data() {
        return {
            QRIsOpen: false,
            password_dialog_visible: false,
            password_dialog_update_flag: 0
        }
    },
    watch : {
        password_dialog_visible () {
            this.password_dialog_update_flag += 1
        }
    },
    computed: {
        roles () {
            return this.account_info['roles']? this.account_info['roles'][0]['role_name']: ''
        }
    },
    methods: {
        handleReportPopup(){
            // this.QRIsOpen = this.QRIsOpen === true? false: true
            this.QRIsOpen = true
            // this.$set(this.QRIsOpen,'active', true)
        },
        handleAddReport(){
            console.log('sent report ====')
        },
        async handle_logout () {
            await this.action_logout()
            this.backstage_router_push({
                path: `/login`,
                query: {}
            })
        },
        handle_change_password () {
            this.backstage_router_push({
                path: `/login`,
            })
        }
    }
};
</script>

<style lang="scss" scoped>
    /deep/ .el-dropdown {
        //margin-right: 20px;
    }
    /deep/ .el-dropdown-link {
        //margin-right: 20px;
        padding-left: 20px;
        padding-right: 20px;
        cursor: default;
    }
    /deep/ .el-dropdown-link:hover {
        background-color: grey;
    }
    /deep/ .el-button{
        border: 0px solid #dcdfe6;
    }

    .personal-panel {
        margin: 20px;
    }
</style>
